import React from 'react';
import '../styling/TAC.css';

const TAC = () => {
    return (
        <div className="terms-container">
            <h1>Terms and Conditions</h1>

            <section className="terms-section">
                <h2>Introduction</h2>
                <p>
                    Welcome to True Hood! These terms and conditions outline the rules and regulations for using our website and purchasing our products.
                </p>
                <p>
                    By accessing this website or placing an order, you agree to be bound by these Terms and Conditions. If you do not agree with any part, please refrain from using the website.
                </p>
            </section>

            <section className="terms-section">
                <h2>Orders</h2>
                <p>
                    Once an order is placed, it cannot be modified or cancelled. Please double-check all details, such as size, address, and contact information before confirming your order.
                </p>
                <p>
                    All orders are subject to availability. We reserve the right to cancel any order due to unforeseen issues with inventory or payment.
                </p>
            </section>

            <section className="terms-section">
                <h2>Returns and Exchanges</h2>
                <p>
                    We currently do not accept any returns/exchanges. So please make sure you place the order carefully. However, if you notice any issue or need to cancel your order, you must contact us within 1 hour of placing the order.
                </p>

                <p>
                    Size exchanges are also not applicable. For oversized fits, we recommend ordering one size up.
                </p>
            </section>

            <section className="terms-section">
                <h2>Shipping</h2>
                <p>
                    Orders are processed within 2–3 business days. Delivery timelines may vary depending on your location. Delays caused by third-party logistics partners are beyond our control.
                </p>
                <p>
                    There are no Shipping charges as of now. Tracking details will be provided once the order is shipped.
                </p>
            </section>

            <section className="terms-section">
                <h2>Product Descriptions</h2>
                <p>
                    We strive to provide accurate information regarding our products. However, slight variations in color, print, or fit may occur due to lighting, photography, or screen resolution differences.
                </p>
            </section>

            <section className="terms-section">
                <h2>Contact</h2>
                <p>
                    For any queries, concerns, or support, feel free to contact us at <strong>truehood.business@gmail.com</strong> or through the contact form on our website.
                </p>
            </section>
        </div>
    );
}

export default TAC;
